import { authClient } from '@stopal/auth/client'
import { resolveAnalyticsExcluded } from '@stopal/shared/analytics-exclusion'
import { useEffect } from 'react'
import { pushEvent, setAnalyticsExcluded } from '@/lib/gtm'
import { withPostHog } from '@/lib/posthog'

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const { data: session } = authClient.useSession()

  useEffect(() => {
    const user = session?.user
    if (user) {
      // Effective per-user analytics exclusion: explicit override or,
      // when unset (Auto), derived from role. Covers staff, contractors, and
      // demo / App Store review accounts — no hardcoded email list.
      const excluded = resolveAnalyticsExcluded(
        user.role,
        user.analyticsExcluded,
      )
      withPostHog((ph) =>
        // PostHog still captures excluded users (kept for product debugging);
        // `exclude_from_analytics` on the person profile lets PostHog reports
        // filter them out via the project's "internal and test users" setting.
        ph.identify(user.id, {
          email: user.email,
          name: user.name,
          exclude_from_analytics: excluded,
        }),
      )
      // Persists (or clears) the GA4 exclusion flag for this device — GA4 is
      // hard-suppressed for excluded users.
      setAnalyticsExcluded(excluded)
      // dataLayer carries only the non-PII id — email/name stay out of GTM/GA4.
      pushEvent('user_identified', { user_id: user.id })
    } else {
      withPostHog((ph) => ph.reset())
      pushEvent('user_signed_out')
    }
  }, [session?.user])

  return <>{children}</>
}
